export default {
    path: '/logout',
    name: 'Logout',
    meta: {
        title: 'Logout',
        documentTitle: 'Logout',
        requiresAuth: false,
    },
    component: () => import( /* webpackChunkName: "Logout" */ '@/views/Logout' ),
};
